var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart-01",
    clipPath: "url(#clip0_1271_3764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M1.33398 1.33398H2.20476C2.36877 1.33398 2.45078 1.33398 2.51677 1.36414C2.57493 1.39072 2.62422 1.43347 2.65875 1.48728C2.69794 1.54835 2.70954 1.62953 2.73273 1.79189L3.04827 4.00065M3.04827 4.00065L3.74953 9.15492C3.83852 9.809 3.88302 10.136 4.03938 10.3822C4.17717 10.5991 4.37471 10.7716 4.60822 10.8789C4.87323 11.0007 5.20328 11.0007 5.86339 11.0007H11.5686C12.197 11.0007 12.5112 11.0007 12.768 10.8876C12.9944 10.7879 13.1886 10.6272 13.3288 10.4235C13.4879 10.1924 13.5467 9.88376 13.6643 9.26649L14.5467 4.63378C14.5881 4.41652 14.6088 4.3079 14.5788 4.22298C14.5525 4.1485 14.5006 4.08577 14.4324 4.046C14.3545 4.00065 14.244 4.00065 14.0228 4.00065H3.04827ZM6.66732 14.0007C6.66732 14.3688 6.36884 14.6673 6.00065 14.6673C5.63246 14.6673 5.33398 14.3688 5.33398 14.0007C5.33398 13.6325 5.63246 13.334 6.00065 13.334C6.36884 13.334 6.66732 13.6325 6.66732 14.0007ZM12.0007 14.0007C12.0007 14.3688 11.7022 14.6673 11.334 14.6673C10.9658 14.6673 10.6673 14.3688 10.6673 14.0007C10.6673 13.6325 10.9658 13.334 11.334 13.334C11.7022 13.334 12.0007 13.6325 12.0007 14.0007Z",
    stroke: "#01588C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1271_3764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerce);
export default __webpack_public_path__ + "static/media/ecommerce.c43fc083fbc2c636388f89ba9848d634.svg";
export { ForwardRef as ReactComponent };